import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import SendMail from '@/components/common/SendMail'
import DdtRestore from '@/components/modules/ddts/DdtRestore'
import CarrierEdit from '@/components/modules/ddts/CarrierEdit'
import ShippingCosts from '@/components/modules/ddts/ShippingCosts'
import DdtsSettings from '@/components/modules/ddts/settings/DdtsSettings'
import PurchaseddtUnload from '@/components/modules/ddts/PurchaseddtUnload'
import CarriersSettings from '@/components/modules/ddts/settings/CarriersSettings'
import PurchaseddtsSettings from '@/components/modules/ddts/settings/PurchaseddtsSettings'
import MovementddtsSettings from '@/components/modules/ddts/settings/MovementddtsSettings'

export const ddts = [
	{
		path: '/purchaseddts',
		redirect: '/ddts/purchaseddts'
	},
	{
		path: '/carriers',
		redirect: '/ddts/carriers'
	},
	{
		path: '/ddts', 
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/ddts',
					text: 'DDT Vendita',
				},				
				{
					to: '/ddts/purchaseddts',
					text: 'DDT Acquisto',
					model: 'purchaseddt'
				},
				{
					to: '/ddts/movementddts',
					text: 'DDT di Trasferimento',
					model: 'movementddt'
				},
				{
					to: '/ddts/carriers',
					text: 'Vettori',
					model: 'carrier'
				},
				{
					to: '/ddts/shippingcosts/',
					text: 'Costi spedizione',
					model: 'carrier'
				},	
			],
		},
		children: [
			{
				path: '/ddts/',
				name: 'ddts-index',
				beforeEnter: (to, from, next) => canAccess('permission', 'ddt', next),
				component: Crud,
				meta: {
					title: trans('ddts')
				},
				props: {
					modelDef: 'ddts',
					actionIcon: 'description',
					title: 'DDT di Vendita',
					styleClass: 'mb-offset',
					enableNumberingAlert: true
				}
			},		
			{
				path: '/ddts/purchaseddts',
				name: 'purchaseddts-index',
				beforeEnter: (to, from, next) => canAccess('permission', 'purchaseddt', next),
				component: Crud,
				meta: {
					title: trans('purchaseddts')
				},
				props: {
					modelDef: 'purchaseddts',
					actionIcon: 'description',
					title: 'DDT di Acquisto',
					styleClass: 'mb-offset'	
				}
			},
			{
				path: '/ddts/movementddts',
				name: 'movementddts-index',
				beforeEnter: (to, from, next) => canAccess('permission', 'movementddt', next),
				component: Crud,
				meta: {
					title: trans('movementddts')
				},
				props: {
					modelDef: 'movementddts',
					actionIcon: 'description',
					title: 'DDT Trasferimento',
					styleClass: 'mb-offset'	
				}
			},
			{
				path: '/ddts/carriers/',
				name: 'carriers-index',
				beforeEnter: (to, from, next) => canAccess('permission', 'carrier', next),
				component: Crud,
				meta: {
					title: trans('carriers')
				},
				props: {
					modelDef: 'carriers',
					actionIcon: 'local_shipping',
					title: 'Vettori',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/ddts/shippingcosts/',
				name: 'shippingcosts-index',	
				beforeEnter: ifAuthenticatedOnline,
				component: ShippingCosts,
				meta: {
					title: trans('shippingcosts')
				},
				props: {
					modelDef: 'shippingcosts',
					actionIcon: 'local_shipping',
					title: 'Costi spedizione'
				}
			},
		],
	},
	{ 
		path: '/ddts/create',
		name: 'ddts-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'ddts',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect,
			footerComponent: 'footer-product-document-table'
		}),
	},
	{ 
		path: '/ddts/:id/edit',
		name: 'ddts-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'ddts',
			id: parseInt(route.params.id),
			disabledUpdateKey: 'closed',
			footerComponent: 'footer-product-document-table'
		}),
	},
	{ 
		path: '/ddts/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 
		props: (route) => ({
			tabs: [
				{
					to: '/ddts/' + parseInt(route.params.id) + '/',
					text: 'DDT di vendita',
				},
			],
		}), 
		children: [
			{
				path: '',
				name: 'ddts-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'DDT di vendita'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'ddts',
					modelClass: 'ddt',
					activities: true,
					maillogs: true,
					fileuploader: true
				}), 
			},
		]
	},
	{ 
		path: '/ddts/movementddts/create',
		name: 'movementddts-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'movementddts',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/ddts/:id/movementddts/edit',
		name: 'movementddts-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'movementddts',
			id: parseInt(route.params.id),
			disabledUpdateKey: 'closed'
		}),
	},
	{ 
		path: '/ddts/movementddts/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 
		props: (route) => ({
			tabs: [
				{
					to: '/ddts/movementddts/' + parseInt(route.params.id) + '/',
					text: 'Ddt di trasferimento',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'movementddts-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Ddt di trasferimento'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'movementddts',
					modelClass: 'movementddt',
					activities: true,
				}), 
			},
		]
	},
	{
		path: '/ddts/ddts-send-mail/:id',
		name: 'ddts-send-mail',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMail,
		props: (route) => ({
			id: parseInt(route.params.id),
			title: 'Invio email DDT',
			model_name: 'ddt',
			route: 'ddts'
		}),
	},
	{ 
		path: '/ddts/ddts-restore/:id',
		name: 'ddts-restore',
		beforeEnter: ifAuthenticatedOnline,
		component: DdtRestore,
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
	},
	{ 
		path: '/ddts/ddts-customer-return/:id',
		name: 'ddts-customer-return',
		beforeEnter: ifAuthenticatedOnline,
		component: DdtRestore,
		props: (route) => ({
			id: parseInt(route.params.id),
			customerReturn: true
		}), 
	},
	{ 
		path: '/ddts/purchaseddts/create',
		name: 'purchaseddts-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'purchaseddts',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect,
			footerComponent: 'footer-product-document-table'
		}),
	},
	{ 
		path: '/ddts/purchaseddts/:id/edit',
		name: 'purchaseddts-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'purchaseddts',
			id: parseInt(route.params.id),
			footerComponent: 'footer-product-document-table'
		}),
	},
	{ 
		path: '/ddts/purchaseddts/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 
		props: (route) => ({
			tabs: [
				{
					to: '/ddts/purchaseddts/' + parseInt(route.params.id) + '/',
					text: 'DDT di acquisto',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'purchaseddts-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'DDT di acquisto'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'purchaseddts',
					modelClass: 'purchaseddt',
					activities: true,
				}), 
			},
		]
	},	
	{ 
		path: '/ddts/purchaseddts-unload/:id',
		name: 'purchaseddts-unload',
		beforeEnter: ifAuthenticatedOnline,
		component: PurchaseddtUnload,
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
	},
	{ 
		path: '/ddts/purchaseddts-supplier-return/:id',
		name: 'purchaseddts-supplier-return',
		beforeEnter: ifAuthenticatedOnline,
		component: PurchaseddtUnload,
		props: (route) => ({
			id: parseInt(route.params.id),
			supplierReturn: true
		}), 
	},
	{ 
		path: '/ddts/carriers/create',
		name: 'carriers-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'carriers',
			redirect: route.params.redirect,
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
		}),
	},
	{ 
		path: '/ddts/carriers/:id/edit',
		name: 'carriers-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: CarrierEdit,
		props: (route) => ({
			modelDef:  'carriers',
			redirect: route.params.redirect,
			id:  parseInt(route.params.id)
		}),
	},
	{ 
		path: '/ddts/carriers/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 
		props: (route) => ({
			tabs: [
				{
					to: '/ddts/carriers/' + parseInt(route.params.id) + '/',
					text: 'Vettore',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'carriers-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Vettore'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'carriers',
					modelClass: 'carrier',
					activities: true,
				}), 
			},
		]
	},	
	{ 
		path: '/settingsddts/templates-ddt/create',
		name: 'templates-ddt-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-ddt',
			redirect: route.params.redirect,
			defaultInput: {type: 'ddt'},			
		}),
	},
	{ 
		path: '/settingsddts/templates-ddt/:id/edit',
		name: 'templates-ddt-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-ddt',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'ddt'},
		}), 
	},
	{ 
		path: '/settingsddts/templates-ddt/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingsddts/templates-ddt/' + parseInt(route.params.id) + '/',
					text: 'Template DDT Vendita',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-ddt-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template DDT Vendita'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-ddt',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},
	{ 
		path: '/settingsddts/',
		name: 'settingsddts',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsddts',
					text: 'DDT Vendita',
				},
				{
					to: '/settingsddts/purchaseddts',
					text: 'DDT di Acquisto',
				},
				{
					to: '/settingsddts/movementddts',
					text: 'DDT di Trasferimento',
				},
				{
					to: '/settingsddts/carriers',
					text: 'Vettori',
				}
			],
		},
		children: [
			{
				path: '/settingsddts/',
				beforeEnter: ifAuthenticatedOnline,
				component: DdtsSettings,
			},
			{
				path: '/settingsddts/purchaseddts',
				beforeEnter: ifAuthenticatedOnline,
				component: PurchaseddtsSettings,
			},
			{
				path: '/settingsddts/movementddts',
				beforeEnter: ifAuthenticatedOnline,
				component: MovementddtsSettings,
			},
			{
				path: '/settingsddts/carriers',
				beforeEnter: ifAuthenticatedOnline,
				component: CarriersSettings,
			}
		],
	},
]